<template>
  <div>
    <product :categoryList="this.categoryList"></product>
    <div
      style="background-color: #f5f5f5; height: 1rem; margin-top: 9.375rem"
    ></div>
    <news :NewsList="this.NewsList" :IndList="this.IndList"></news>
  </div>
</template>

<script>
import news from '../Index_components/Application_news.vue'
import api from '@/utils/api'
import product from '../Index_components/Application_product.vue'
export default {
  name: 'Applications',
  props: {
      NewsList: {
          type: Array,
          default: null
      },
      IndList: {
          type: Array,
          default: null
      },
      categoryList: {
          type: Array,
          default: null
      }
  },
  components: {
    news,
    product,
  },
}
</script>
<style scoped></style>
